import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ActionParams, type AsyncThunkCreator } from "../../../index";
import { PRODUCT_CLIENT_REDUCER } from "../types";
import { getPaymentMethodErrorCode } from "./paymentMethodError";

type Payload = {
  productId: string;
  authorId: string;
  paymentGatewayCustomerId: string;
  paymentMethodId: string;
};

type UpdatePaymentMethodParams = Omit<ActionParams<Payload>, "onFailure"> & {
  onFailure?: (errorCode: string) => void;
};

export const updatePaymentMethodForSubscription = createAsyncThunk<
  void,
  UpdatePaymentMethodParams,
  AsyncThunkCreator<string>
>(
  `${PRODUCT_CLIENT_REDUCER}/updatePaymentMethodForSubscription`,
  async ({ payload, onSuccess, onFailure }, { rejectWithValue, extra: { productApi, analytics } }) => {
    try {
      await productApi.post("/update-client-payment-method", payload);
      analytics.track("update_payment_method", {
        productId: payload.productId,
        authorId: payload.authorId,
      });
      onSuccess?.();
    } catch (e) {
      const errorCode = getPaymentMethodErrorCode(e);
      onFailure?.(errorCode);

      return rejectWithValue(errorCode);
    }
  },
);
